import React from 'react';

// Logo configuration
const LOGO_CONFIG = {
  // Use relative URL from root
  url: '/YellowSeal_lluislaw.png', alt: 'Lluis Law Logo',  fallbackText: 'Lluis Law'
};

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "h-12" }) => {
  const [imageError, setImageError] = React.useState(false);

  // If image fails to load, show text fallback
  if (imageError) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div className="text-center">
          <h1 className="font-serif text-3xl font-bold text-amber-700 tracking-tight">
            {LOGO_CONFIG.fallbackText}
          </h1>
          <p className="text-xs font-semibold text-slate-500 tracking-[0.3em] uppercase mt-1">
            APC
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img
        src={LOGO_CONFIG.url}
        alt={LOGO_CONFIG.alt}
        className="h-full w-auto object-contain"
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default Logo;
